import React from "react";
import Swal from "sweetalert2";
import { roomTypeColumns } from "./RoomTypeTableData";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../../Common/DataTable/DataTable";

const RoomTypeTable = ({ data, loading, onEdit, onDelete }) => {
  const confirmDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the room type.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(id); 

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Room type deleted successfully.",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const tableData = data.map((row, index) => ({
    id: index + 1,
    name: row.name,
    base_price: row.base_price,
    extra_adult_charge: row.extra_adult_charge,
    extra_child_charge: row.extra_child_charge,
    active: row.is_active ? (
      <span className="badge bg-success">Active</span>
    ) : (
      <span className="badge bg-secondary">Inactive</span>
    ),
    actions: (
      <>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onEdit(row)}
        >
          <i className="bi bi-pencil-square"></i>
        </button>

        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => confirmDelete(row.id)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />

      {loading ? (
        <p className="text-center py-4">
          <span className="spinner-border"></span>
        </p>
      ) : (
        <DataTable columns={roomTypeColumns} data={tableData} />
      )}
    </>
  );
};

export default RoomTypeTable;
